import React, { useState } from 'react';

import DateFormat from '@core/components/display/datetime/DateFormat';
import Image from 'next/future/image';
import Link from 'next/link';

import fetchAttachment from '@/utils/functions/wordpress/fetchAttachment';

export type NewsletterDailyPageLayoutProps = {
    id: number;
    time: string;
    list: string;
    subject: string;
};

const NewsletterDailyPageLayout = (props: NewsletterDailyPageLayoutProps) => {
    const { id, time, list, subject } = props;
    const [imageUrl, setImageUrl] = useState('/images/newsletter/placeholder.png');

    fetchAttachment(`Newsletter_${id}`).then(response => {
        if (response.length > 0) {
            setImageUrl(response[0]!.source_url! as string);
        }
    });

    return (
        <div key={`newsletter-${id}`} className="flex justify-start items-start flex-grow p-6">
            <Link href={`/newsletter/issue/${id}`} passHref>
                <a className="border border-primary hover:border-black">
                    <Image src={imageUrl} width={160} height={90} alt="NL" />
                </a>
            </Link>
            <div className="flex flex-col justify-start items-start flex-grow gap-2 px-5">
                <div className="items-center gap-2 py-1">
                    <p className="flex-grow-0 flex-shrink-0 text-xxs text-left uppercase text-primary">
                        <DateFormat dateStringOrTimestamp={time} />
                    </p>
                    <p className="text-xxs text-left text-gray-500">{list}</p>
                </div>
                <div className="flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-3">
                    <h3 className="flex-grow w-[125px] text-base font-semibold text-left text-[#110b29]">
                        <Link href={`/newsletter/issue/${id}`} passHref>
                            <a className="hover:text-primary">{subject}</a>
                        </Link>
                    </h3>
                </div>
            </div>
        </div>
    );
};

export default NewsletterDailyPageLayout;
